const handleSelect = () => {
  const selectors = {
    select: '.js-cat-drop-down',
  };

  const state = {
    active: 'is-active',
  };

  const select = document.querySelector(selectors.select);

  if (!select) return;

  select.addEventListener('click', () => select.classList.toggle(state.active));

  document.addEventListener('click', (e) => {
    if (!e.target.closest(selectors.select)) {
      select.classList.remove(state.active);
    }
  });
};

export default handleSelect;
